import React, { Fragment, useState } from 'react';
import axios from 'axios';
import authApiService from '../services/authServices';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../layout/frontlayout/css/bg_regular.css';
import '../layout/frontlayout/css/frontBox.css';
import { Link } from 'react-router-dom';
// import ForgotPasswordForm from './ForgotPasswordForm';
import Forgot from './Forget/Forgot';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { ThreeDots } from 'react-loader-spinner';
import useLoading from '../hooks/useLoading';

// Remove the TypeScript declare statement
// declare const jqUpdateLoginBoxHeader: (text: string) => void;

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [currentForm, setCurrentForm] = useState('login');
    const [showPassword, setShowPassword] = useState(false);
    const { isLoading, withLoading } = useLoading();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setUsernameError('');
        setPasswordError('');

        if (!username) {
            setUsernameError('Username is required.');
            return;
        }
        if (!password) {
            setPasswordError('Password is required.');
            toast.error('Password is required.');
            return;
        }

        await withLoading(async () => {
            try {
                const response = await authApiService.post("login", { username, password });
                console.log('Login response:', response);
                console.log('Response data:', response.data);
                console.log('Response data structure:', JSON.stringify(response.data, null, 2));

                // Check if login is successful (response has accessToken)
                if (response.data.accessToken) {
                    console.log('Response code is 200, proceeding with city save...');
                    console.log('Login successful:', response.data.accessToken);
                    localStorage.setItem('accessToken', response.data.accessToken);
                    window.dispatchEvent(new Event('authChange'));
                    
                    // Save city data from login response - NEW response structure
                    if (response.data.cityId && response.data.city) {
                        console.log('CityId from response:', response.data.cityId);
                        console.log('City name from response:', response.data.city);
                        
                        // Clear existing city data first
                        localStorage.removeItem('selectedCity');
                        console.log('Cleared existing selectedCity');
                        
                        const cityData = {
                            id: response.data.cityId,
                            name: response.data.city,
                            state: "Unknown", // Default value since not provided
                            active: true,
                            isDelete: 0,
                            version: 1
                        };
                        console.log('Saving city data:', cityData);
                        
                        // Set city data in localStorage
                        localStorage.setItem('selectedCity', JSON.stringify(cityData));
                        console.log('City data saved to localStorage');
                        
                        // Verify localStorage was set
                        const verifyCity = JSON.parse(localStorage.getItem('selectedCity'));
                        console.log('Verification - localStorage selectedCity:', verifyCity);
                        
                        // Check if data is actually saved
                        if (verifyCity && verifyCity.name === 'Paris') {
                            console.log('✅ Paris city successfully saved to localStorage');
                        } else {
                            console.log('❌ Failed to save Paris city to localStorage');
                        }
                        
                        // Force update header immediately and navigate
                        window.dispatchEvent(new Event('cityChange'));
                        navigate('/carter/home');
                    } else {
                        console.log('No cityId or city found in response');
                        // Navigate even if no city found
                        navigate('/carter/home');
                    }
                } else {
                    console.log('Login failed - no accessToken in response');
                    setError('Login failed. Please try again.');
                }
                localStorage.setItem('accessToken', response.data.accessToken);
                window.dispatchEvent(new Event('authChange'));

            } catch (err) {
                console.error('Login failed:', err);
                if (err.response && err.response.data) {
                    setError(err.response.data.message || 'Login failed.');
                    toast.error(err.response.data.message || 'Login failed.');
                } else {
                    setError('An unexpected error occurred.');
                    toast.error('An unexpected error occurred.');
                }
            }
        });
    };

    const handleForgotPasswordClick = (e) => {
        e.preventDefault();
        setCurrentForm('forgotPassword');
        // Call the function from intropage.js via the window object
        if (typeof window.jqUpdateLoginBoxHeader === 'function') {
            window.jqUpdateLoginBoxHeader('FORGOT PASSWORD');
        }
    };

    const handleBackToLoginClick = () => {
        setCurrentForm('login');
        setError('');
        setUsernameError('');
        setPasswordError('');
        // Call the function from intropage.js via the window object
        if (typeof window.jqUpdateLoginBoxHeader === 'function') {
            window.jqUpdateLoginBoxHeader('Log in');
        }
    };


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div id="login-box" style={{ display: 'none' }}>
            {currentForm === 'login' ? (
                <Fragment>
                    <p className="text-left">Welcome to the website</p>
                    <form style={{ paddingRight: '5px' }} className="signin" onSubmit={handleSubmit}>
                        <fieldset className="textbox">
                            <label className="username">
                                <span id="error-msg"></span>
                            </label>
                            {error && <p className="error-message">{error}</p>}
                            <div>
                                <input
                                    type="text"
                                    placeholder="ENTER USERNAME"
                                    className="login-input"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    maxLength={120}
                                    disabled={isLoading}
                                />
                                {usernameError && <p className="error-message">{usernameError}</p>}
                                <div className="clear"></div>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="ENTER PASSWORD"
                                        className="login-input"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        maxLength={20}
                                        style={{ paddingRight: '40px', width: '100%' }}
                                        disabled={isLoading}
                                    />
                                    <span
                                        onClick={togglePasswordVisibility}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '40%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            zIndex: 1,
                                        }}
                                    >
                                        <Icon
                                            path={showPassword ? mdiEyeOutline : mdiEyeOffOutline}
                                            size={1}
                                            color="currentColor"
                                        />
                                    </span>
                                </div>

                                {passwordError && <p className="error-message">{passwordError}</p>}
                            </div>
                            <div className="clear"></div>
                            <div className="row">
                                <div id="login-bottom2" className="col-sm-5">
                                    <span style={{ position: 'relative', top: '10px', }} >
                                        <input type="checkbox" name="rememberMe" id="rememberMe" value="true" style={{ width: '10px', marginRight: '4px', marginTop: '3px' }} disabled={isLoading} />
                                        <label className="check-txt" htmlFor="rememberMe">Remember me</label>
                                    </span>
                                </div>
                                <div className="col-sm-7">
                                    <input type="hidden" id="fname" value="" />
                                    <p id="login-bottom3">
                                        <a href="#" id="forgot-lnk" className="forgot" onClick={handleForgotPasswordClick}>Forgot your password?</a>
                                    </p>
                                </div>
                            </div>
                            <div id="login-bottom1">
                                <button className="submit button" type="submit" disabled={isLoading}>
                                    {isLoading ? (
                                        <ThreeDots
                                            height="20"
                                            width="60"
                                            radius="9"
                                            color="#ffffff"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{}}
                                            wrapperClassName=""
                                            visible={true}
                                        />
                                    ) : (
                                        'Login'
                                    )}
                                </button>
                                <div style={{ clear: 'both' }}></div>
                                {/* <Link to="/carter/signup" id="signup-lnk" >Sign Up</Link> */}
                            </div>
                        </fieldset>
                    </form>
                </Fragment>
            ) : (
                <Forgot onBackToLogin={handleBackToLoginClick} />
            )}
        </div>
    );
}

export default Login;

